<div class="responsive-card d-flex flex-column" [style.gap.rem]="2.5">
  <div class="d-flex flex-column" [style.gap.rem]="2">
    <div class="d-flex gap-3">
      <div class="responsive-card-title flex-grow-1" i18n>Contacts</div>
      <app-text-button (buttonClicked)="editContactsClicked.emit()" [type]="ButtonTypeEnum.accent">
        <div class="d-flex gap-2 align-items-center">
          <span i18n>Edit</span>
          <img src="assets/icons/primary/Chevron%20Right.svg" alt="" />
        </div>
      </app-text-button>
    </div>
    <div class="contacts-card-header" i18n>Primary Contact</div>
    <app-employer-contact-card
      [contact]="primaryContact"
      [isCollapsed]="primaryContactCollapseState"
      (toggle)="primaryContactCollapseState = !primaryContactCollapseState" />
  </div>

  <ng-container *ngIf="additionalContacts?.length">
    <div class="d-flex flex-column gap-4">
      <div class="d-flex gap-2 align-items-center">
        <div class="contacts-card-header flex-grow-1" i18n>Additional Contacts</div>
        <div class="d-flex gap-2">
          <button class="no-style-button" (click)="expandAll()">
            <app-simple-pill text="Expand All" imageSrc="assets/icons/dark/Expand.svg" i18n-text />
          </button>
          <button class="no-style-button" (click)="collapseAll()">
            <app-simple-pill text="Collapse All" i18n-text imageSrc="assets/icons/dark/Collapse.svg" />
          </button>
        </div>
      </div>
      <app-employer-contact-card
        *ngFor="let contact of additionalContacts"
        [contact]="contact"
        [isCollapsed]="!additionalContactsExpandedState[contact.id]"
        (toggle)="onCardToggle(contact)" />
    </div>
  </ng-container>
</div>
